import styled from 'styled-components';
import theme from '../../shared/theme';

export const AvatarContainer = styled.div`
  position: relative;
  .ant-avatar {
    background-color: ${props =>
      `${theme.avatar[`avatar${props.colorIndex}`]}`};
  }
`;
export const AvatarIconContainer = styled.div`
  position: absolute;
  bottom: -4px;
  right: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.background};
`;
